import "./authPage.scss"
import { AuthStaticContent, LoginForm } from '../../components'
import { RLogo, RLogoLight } from "../../assets/svgIcon/customIcon"
// import { useTranslation } from "react-i18next";


const Login = () => {
  // const { t,i18n } = useTranslation();
  // const changeLanguage = (lng: any) => {
  //   i18n.changeLanguage(lng);
  // };
  return (
    <div className='login-page'>
      <RLogoLight className='r-logo d-lg-block d-none' />
      <RLogo className='r-logo d-lg-none d-block' />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xxl-3 col-xl-4 col-lg-5 col-md-12 p-md-0">
            <AuthStaticContent mobileLoginContent={true} />
          </div>
          <div className="col-xxl-9 col-xl-8 col-lg-7 col-md-12">
            <div className='login-page-form'>
              {/* <h1>{t('greeting')}</h1>;
              <button onClick={() => changeLanguage('en')}>English</button>
              <button onClick={() => changeLanguage('fr')}>French</button> */}
              <LoginForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login